/**
 * IntersectionObserver поддерживается?
 */
let supported = false;

// Проверяем наличие всех нужных объектов единожды при подключении модуля.
if (
	( 'IntersectionObserver' in window )
	&& ( 'IntersectionObserverEntry' in window )
	&& ( 'intersectionRatio' in (window as any).IntersectionObserverEntry.prototype )
)
{
	// Полифилим свойство isIntersecting для Edge 15.
	if ( !( 'isIntersecting' in (window as any).IntersectionObserverEntry.prototype ) )
	{
		Object.defineProperty(
			(window as any).IntersectionObserverEntry.prototype,
			'isIntersecting',
			{
				get( this: any ): boolean
				{
					return this.intersectionRatio > 0;
				},
			},
		);
	}
	
	supported = true;
}

/**
 * Проверяет поддержку IntersectionObserver.
 */
function isIntersectionObserverSupported(): boolean
{
	return supported;
}

/**
 * Module.
 */
export {
	isIntersectionObserverSupported as default,
};



// WEBPACK FOOTER //
// ./app/utils/isIntersectionObserverSupported.ts